export default __webpack_public_path__ + "static/media/Ажлын хэсэг ахлагч.01088a98.pdf";